import { connect } from 'react-redux'
import {
  loadInstalledElements, loadTemplate, selectElementGroup, selectElementSubGroup,
  selectDepartment, searchTemplate, types, loadInstalledElement,
} from '../../../../actions/elements_order'
import { createLoadingSelector } from '../../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.LOAD_INSTALLED_ELEMENT])

function mapStateToProps (state) {
  return {
    dictionaries: {
      locationGroups: state.elementsOrder?.dictionaries?.locationGroups,
      locationSubGroups: state.elementsOrder?.dictionaries?.locationSubGroups,
      locationDepartments: state.elementsOrder?.dictionaries?.locationDepartments,
    },
    filtered: {
      departments: state.elementsOrder?.filtered?.departments || [],
      elementSubGroups: state.elementsOrder?.filtered?.elementSubGroups || [],
    },
    currentElementGroup: state.elementsOrder?.currentElementGroup,
    currentDepartment: state.elementsOrder?.currentDepartment,
    currentElementSubGroup: state.elementsOrder?.currentElementSubGroup,
    currentReplaceElementId: state.elementsOrder?.currentReplaceElementId,
    currentTemplateLoading: loadingSelector(state),
    currentTemplateData: state.elementsOrder?.currentTemplateData,
    searchTerm: state.elementsOrder?.searchTerm,
    installedElements: state.elementsOrder?.installedElements,
    installedElementsLoading: state.elementsOrder?.installedElementsLoading,
  }
}

function mapDispatchToProps (dispatch) {
  return {
    loadInstalledElements: (locationId, filterParams) => dispatch(loadInstalledElements(locationId, filterParams)),
    loadInstalledElement: (locationId, elementId) => dispatch(loadInstalledElement(locationId, elementId)),
    selectElementGroup: elementGroupId => dispatch(selectElementGroup(elementGroupId)),
    selectElementSubGroup: elementSubGroupId => dispatch(selectElementSubGroup(elementSubGroupId)),
    selectDepartment: departmentId => dispatch(selectDepartment(departmentId)),
    searchTemplate: searchTerm => dispatch(searchTemplate(searchTerm)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
